export default __webpack_public_path__ + "static/media/imageCoverPhotoBlank.e624051d.jpg";